import { isPlainObject } from "./payload";

// A bare https origin: no path, wildcard, quote, whitespace or separator can reach the policy.
const ORIGIN = /^https:\/\/[a-z0-9-]+(\.[a-z0-9-]+)*(:\d{1,5})?$/;

/** Keeps only declared domains that are bare https origins. */
export function allowedOrigins(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.filter(
    (entry): entry is string => typeof entry === "string" && ORIGIN.test(entry)
  );
}

/** The CSP for a view, from its `_meta.ui.csp` declaration. */
export function contentSecurityPolicy(meta: unknown): string {
  const ui = isPlainObject(meta) ? meta.ui : undefined;
  const csp = isPlainObject(ui) ? ui.csp : undefined;
  const declared = isPlainObject(csp) ? csp : {};
  const images = allowedOrigins(declared.resourceDomains);
  const connect = allowedOrigins(declared.connectDomains);
  return [
    "default-src 'none'",
    "script-src 'unsafe-inline'",
    "style-src 'unsafe-inline'",
    ["img-src data:", ...images].join(" "),
    connect.length ? `connect-src ${connect.join(" ")}` : "connect-src 'none'",
    "base-uri 'none'",
    "form-action 'none'",
  ].join("; ");
}

/** The view's HTML with its CSP injected ahead of any script. */
export function buildSrcDoc(html: string, meta: unknown): string {
  const tag = `<meta http-equiv="Content-Security-Policy" content="${contentSecurityPolicy(meta)}">`;
  const head = html.match(/<head(\s[^>]*)?>/i);
  if (!head || head.index === undefined) return tag + html;
  const end = head.index + head[0].length;
  return html.slice(0, end) + tag + html.slice(end);
}
